import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Handler from "../Helpers/Handler";
import { toast } from "react-toastify";
import { loadingFalse, loadingTrue } from "../Reducer/loaderSlice";
import Logo from "../Assets/images/logo.png";
import { reloadWindowToPath, setCookie } from "../Helpers/Utils";

const Login = () => {
    const dispatch = useDispatch();
    const loading = useSelector(state => state.loading.loading);
    const [form, setForm] = useState({ email: "", password: "" });
    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
    const [showPassword, setShowPassword] = useState(false);
    const handleLogin = async e => {
        e.preventDefault();
        dispatch(loadingTrue());
        try {
            const res = await Handler({ method: "post", url: "/auth/login.php", data: form });
            console.log(res);
            if (res?.success) {
                toast.success(res.data.message);
                setCookie("token", res.data.token);
                setCookie("role", res.data.user?.role || 'admin');
                setCookie("userName", res.data.user?.name || 'User');
                setTimeout(() => {
                    reloadWindowToPath("/");
                }, 1000);
            } else {
                toast.error(res?.data?.message || "Login failed");
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || "Login failed");
        }
        dispatch(loadingFalse());
    };

    useEffect(() => {
        dispatch(loadingFalse());
    }, []);

    return (
        <div className="login-wrapper">
            <div className="login-card">
                <img src={Logo} alt="Login" className="login-image mb-4" />
                <div className="login-brand">
                    <h2>Welcome Back 👋</h2>
                    <p>Login to continue</p>
                </div>
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" name="email" className="form-control" placeholder="Enter email" onChange={handleChange} required />
                    </div>
                    <div className="form-group password-group">
                        <label>Password</label>
                        <div className="password-wrapper">
                            <input type={showPassword ? "text" : "password"} name="password" className="form-control" placeholder="Enter password" onChange={handleChange} required />
                            <i className={`bx ${showPassword ? "bx-hide" : "bx-show"} password-toggle`} onClick={() => setShowPassword(!showPassword)} ></i>
                        </div>
                    </div>

                    <button className="btn login-btn w-100" disabled={loading}>
                        {loading ? (<><span className="spinner-border spinner-border-sm me-2"></span>Signing in...</>) : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
